import { useSuspenseQuery } from '@tanstack/react-query';

import { getRequest } from '@/api/rest/hooks/requests/get';
import {
  GET_PLOT_PORTFOLIO_PRODUCTS_PATH,
  GetPlotPortfolioProductsErrorDto,
  GetPlotPortfolioProductsRequestQueryParams,
  GetPlotPortfolioProductsSuccessDto,
} from '@/api/rest/resources/types/plotPortfolioProducts';

type SuccessDto = GetPlotPortfolioProductsSuccessDto;
type ErrorDto = GetPlotPortfolioProductsErrorDto;
type QueryParams = GetPlotPortfolioProductsRequestQueryParams;

export const PLOT_PORTFOLIO_PRODUCTS_QUERY_KEY = 'plot-portfolio-products';

export const usePlotPortfolioProducts = (queryParams?: QueryParams) => {
  const queryFn = async () => {
    return getRequest<SuccessDto, undefined, QueryParams>(GET_PLOT_PORTFOLIO_PRODUCTS_PATH, undefined, queryParams);
  };

  return useSuspenseQuery<SuccessDto, ErrorDto>({
    queryKey: [PLOT_PORTFOLIO_PRODUCTS_QUERY_KEY, queryParams],
    queryFn,
    staleTime: 1000 * 60 * 5,
  });
};
